export const UI_SETTINGS = {
  SIDEBAR_VIEW: 'sidebar_view',
};